import { createContext, useContext } from "react";

import type {
  Price,
  TurnoverGroup,
  VatRate,
} from "~/providers/general-provider";

interface GeneralContext {
  vatRates: VatRate[];
  turnoverGroups: TurnoverGroup[];
  prices: Price[];
}

export const GeneralContext = createContext<GeneralContext | undefined>(
  undefined,
);

export const useGeneral = () => {
  const context = useContext(GeneralContext);

  if (context === undefined) {
    throw new Error(
      "useGeneral must be used within a GeneralProvider, but no provider was found",
    );
  }

  return context;
};
